/**************************************************
 * Nombre:       BarraCell
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Badge, Box, ButtonBase, Drawer, Grid, IconButton, Typography} from "@mui/material";
import logo from '../../Recursos/logo_color.svg'
import {Close, Menu, ShoppingCart, WhatsApp} from '@mui/icons-material'
import {useState} from "react";
import {DIRECCIONLOCALES, REDES, SECCIONES} from "../../Constantes";
import {useNavigate} from "react-router";
import {irUrl} from "../../Utilidades/irUrl";
import {theme} from "../../Tema";
import {useIrRuta} from "../../Utilidades/useIrRuta";
import {useMenuPop} from "../../Modulo_Menu_Pop/Hooks/useMenuPop";
import {iniciarChatWass} from "../../Utilidades/iniciarChatWass";
import {useProductosCarrito} from "../../Modulo_Carrito_Flotante/Funcionamiento/Hooks/useProductosCarrito";
import {useCarritoFlotante} from "../../Modulo_Carrito_Flotante/Hooks/useCarritoFlotante";

const BarraCell = ({negro}) => {
    const navigate = useNavigate()
    const {ir} = useIrRuta()
    const [open, setOpen] = useState(false)
    const {MenuPop, abrirMenu} = useMenuPop()
    const {Carrito, abrir} = useCarritoFlotante()
    const {productos} = useProductosCarrito()

    const clickMenu = (it) => {

        iniciarChatWass({mensaje: 'Hola Quesuditas ' + it.nombre, numero: it.celular})

    }


    return (
        <Grid
            container
            justifyContent={'space-between'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{backgroundColor: negro ? '#000' : '#00000000', px: 3, py: 3}}
        >

            <Carrito/>

            <Box>
                <img
                    onClick={() => navigate('/Home')}
                    src={logo} width={160} height={'auto'} style={{marginTop: -5}}/>
            </Box>

            <MenuPop opciones={DIRECCIONLOCALES} click={clickMenu}/>

            <Box>
                <IconButton
                    onClick={(e) => abrirMenu(e)}
                    sx={{backgroundColor: '#fff', mr: 1}}
                >
                    <WhatsApp sx={{fill: theme.palette.primary.main}}/>
                </IconButton>

                <IconButton sx={{p: 1, backgroundColor: theme.palette.primary.main,mr: 1}}
                            onClick={() => abrir()}>
                    <Badge badgeContent={productos.length} color="secondary">
                        <ShoppingCart sx={{fill: '#fff'}}/>
                    </Badge>
                </IconButton>

                <IconButton
                    onClick={() => setOpen(true)}
                    sx={{backgroundColor: theme.palette.primary.main}}
                >
                    <Menu sx={{fill: '#fff'}}/>
                </IconButton>


            </Box>


            <Drawer open={open} onClose={() => setOpen(false)}
                    anchor={'right'}
            >

                <Grid container size={{xs: 12, ms: 12, md: 12}}>
                    <IconButton
                        onClick={() => setOpen(false)}
                    >
                        <Close sx={{fill: '#fff'}}/>
                    </IconButton>
                </Grid>

                <Grid container size={{xs: 12, ms: 12, md: 12}}
                      sx={{width: 300, p: 2, marginTop: 2, justifyContent: 'center'}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'center', marginTop: 2}}>
                        <ButtonBase
                            onClick={() => {
                                setOpen(false)
                                setTimeout(() => {
                                   navigate('/Home');
                                }, 500)
                            }}

                        >
                            <Typography
                                sx={{
                                    color: '#fff',
                                    fontSize: 20,
                                    fontWeight: 600,
                                    textAlign: 'center'
                                }}>{'Inicio'}</Typography>
                        </ButtonBase>
                    </Grid>


                    {SECCIONES.map((item, index) => (
                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'center', marginTop: 2}}>
                            <ButtonBase
                                onClick={() => {
                                    setOpen(false)
                                    setTimeout(() => {
                                        ir(item)
                                    }, 500)
                                }}

                            >
                                <Typography
                                    sx={{
                                        color: '#fff',
                                        fontSize: 20,
                                        fontWeight: 600,
                                        textAlign: 'center'
                                    }}>{item}</Typography>
                            </ButtonBase>
                        </Grid>
                    ))}


                    <Grid container size={{xs: 12, ms: 12, md: 12}}
                          sx={{bottom: '2%', justifyContent: 'center', marginTop: 50}}>
                        <img src={logo} width={180} height={'auto'}/>
                    </Grid>

                    <Grid container size={{xs: 10, ms: 12, md: 12}}
                          sx={{bottom: '2%', justifyContent: 'center', marginTop: 2}}>
                        {REDES.map((item, index) => {
                            return (
                                <Grid container size={{xs: 3, ms: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                    <IconButton
                                        onClick={() => irUrl(item.url)}
                                    >
                                        <img src={item.imgColor} width={32} height={'auto'}/>
                                    </IconButton>
                                </Grid>
                            )
                        })}
                    </Grid>


                </Grid>

            </Drawer>

        </Grid>
    )

}
export default BarraCell